import React from 'react';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '../../context/theme/theme';
import { CustomText, CustomLink } from './FooterComponent';
import useResponsive from '../../utils/responsive';
import { useLanguage } from '../../context/language/language';
import configuration from '../../configs/configuration';
import { SITES } from '../../constant/common/sites';
import { contactEmail, contactPhone } from '../../utils/constant';
import { getImageURL } from '../../utils/getImageURL';
import { trackClickFooterEmailContactUs, trackClickFooterSocialIcon } from '../../utils/eventTracking';

const mastercardLogo = getImageURL('/logo/master-card-logo.svg');
const visaLogo = getImageURL('/logo/visa-logo.svg');
const trueMoneyLogo = getImageURL('/logo/true-money-logo.svg');
const touchLogo = getImageURL('/logo/touch-logo.svg');
const facebookIcon = getImageURL('/icon/facebook.svg');
const youtubeIcon = getImageURL('/icon/youtube.svg');
const lineIcon = getImageURL('/icon/line.svg');
const twitterIcon = getImageURL('/icon/twitter.svg');
const instagramIcon = getImageURL('/icon/instagram.svg');
const ocbpLogo = getImageURL('/logo/ocbp-logo.svg');
const dbdLogo = getImageURL('/logo/dbd-logo.svg');

const facebookMYRef = 'https://www.facebook.com/LotussMalaysia';
const youtubeMYRef = 'https://www.youtube.com/channel/UCcfT3iiR6Zc_bJGP_73wlOg';
const instagramMYRef = 'https://www.instagram.com/lotussmalaysia/';

const facebookTHRef = 'https://www.facebook.com/lotussth';
const youtubeTHRef = 'https://www.youtube.com/c/Lotussth';
const instagramTHRef = 'https://www.instagram.com/lotuss/';
const lineTHRef = 'https://liff.line.me/1645278921-kWRPP32q?accountId=lotussth&openerPlatform=native&openerKey=talkroom%3Aheader#mst_challenge=50N0brBNxNv1DbQbeK8r_qN6GxfHygw1-zan6Fb-QFE';
const twitterTHRef = 'https://twitter.com/lotussth?s=21';

const useStyles = makeStyles((theme) => ({
  logo: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  pb10: {
    paddingBottom: 10,
  },
  mastercardLogo: {
    width: 38,
    height: 32,

    [theme.breakpoints.up('md')]: {
      width: 38,
      height: 24,
    },
  },
  visaLogo: {
    width: 61,
    height: 32,

    [theme.breakpoints.up('md')]: {
      width: 57,
      height: 24,
    },
  },
  trueMoneyLogo: {
    width: 93,
    height: 32,

    [theme.breakpoints.up('md')]: {
      width: 86,
      height: 24,
    },
  },
  touchLogo: {
    width: 24,
    height: 24,
  },
  socialIcon: {
    width: 32,
    height: 32,

    [theme.breakpoints.up('md')]: {
      width: 24,
      height: 24,
    },
  },
  dbdLogo: {
    width: 60,
    height: 32,

    [theme.breakpoints.up('md')]: {
      width: 62,
      height: 24,
    },
  },
}));

const TelLink = styled.a(({ theme }) => ({
  ...theme.fonts.header3,
  color: theme.colors.white,
}));

const SupportSite = () => {
  const { isMobile } = useResponsive();
  const theme = useTheme();
  const classes = useStyles();
  const word = useLanguage();
  return (
    <Grid
      container
      justify="space-between"
      spacing={4}
      className={classes.pb10}
    >
      {!isMobile && <Grid item xs={12} md={2} style={{ paddingRight: 2 }} />}
      <Grid item xs={12} md={4}>
        <CustomText theme={theme}>
          {word('Footer.PaymentMethods')}
        </CustomText>
        <div className={classes.logo}>
          <CustomLink
            style={{ marginRight: 10 }}
            theme={theme}
            as="span"
          >
            <img width={40} height={28} src={mastercardLogo} className={classes.mastercardLogo} alt="MasterCard" />
          </CustomLink>
          <CustomLink
            style={{ marginRight: 10 }}
            theme={theme}
            as="span"
          >
            <img width={52} height={28} src={visaLogo} className={classes.visaLogo} alt="Visa" />
          </CustomLink>
          {configuration.siteCode === SITES.MALAYSIA_SITE && (
            <CustomLink
              style={{ marginRight: 10 }}
              theme={theme}
              as="span"
            >
              <img width={118} height={28} src={touchLogo} className={classes.touchLogo} alt="Touch 'n go ewallet" />
            </CustomLink>
          )}
        </div>
      </Grid>
      {
        !isMobile && (
        <Grid item xs={12} md={configuration.siteCode === SITES.MALAYSIA_SITE ? 4 : 2}>
          <CustomText theme={theme} className="hle-footer-item-list-header">
            {word('Footer.ContactUs')}
          </CustomText>
          <ul className="hle-footer-item-list">
            <li>
              <CustomLink
                id="footer-mail"
                data-cta-name-en="Footer"
                data-cta-name-th="ส่วนท้าย"
                data-cta-type="Link"
                theme={theme}
                href={`mailto:${contactEmail}`}
                onClick={() => trackClickFooterEmailContactUs()}
              >
                {contactEmail}
              </CustomLink>
            </li>
            <li>
              <TelLink
                id="footer-tel"
                data-cta-name-en="Footer"
                data-cta-name-th="ส่วนท้าย"
                data-cta-type="Link"
                href={`tel:${contactPhone}`}
              >
                {contactPhone}
              </TelLink>
            </li>
          </ul>
        </Grid>
        )
        }
      <Grid item xs={12} md={2}>
        <CustomText theme={theme} className="hle-footer-item-list-header">
          {word('Header.FollowUs')}
        </CustomText>
        <div className={classes.logo}>
          <CustomLink
            id="support-site-fb"
            data-cta-name-en="Support Site"
            data-cta-name-th="เว็บไซต์สนับสนุน"
            data-cta-type="Link"
            style={{ marginRight: 10 }}
            theme={theme}
            href={configuration.siteCode === SITES.MALAYSIA_SITE ? facebookMYRef : facebookTHRef}
            target="_blank"
            onClick={() => trackClickFooterSocialIcon('facebook')}
          >
            <img width={24} height={24} src={facebookIcon} className={classes.socialIcon} alt="Facebook" />
          </CustomLink>
          <CustomLink
            id="support-site-youtube"
            data-cta-name-en="Support Site"
            data-cta-name-th="เว็บไซต์สนับสนุน"
            data-cta-type="Link"
            style={{ marginRight: 8 }}
            theme={theme}
            href={configuration.siteCode === SITES.MALAYSIA_SITE ? youtubeMYRef : youtubeTHRef}
            target="_blank"
            onClick={() => trackClickFooterSocialIcon('youtube')}
          >
            <img width={24} height={24} src={youtubeIcon} className={classes.socialIcon} alt="Youtube" />
          </CustomLink>
          <CustomLink
            id="support-site-instagram"
            data-cta-name-en="Support Site"
            data-cta-name-th="เว็บไซต์สนับสนุน"
            data-cta-type="Link"
            style={{ marginRight: 8 }}
            theme={theme}
            href={configuration.siteCode === SITES.MALAYSIA_SITE ? instagramMYRef : instagramTHRef}
            target="_blank"
            onClick={() => trackClickFooterSocialIcon('instagram')}
          >
            <img width={24} height={24} src={instagramIcon} className={classes.socialIcon} alt="Instagram" />
          </CustomLink>
          {configuration.siteCode === SITES.THAILAND_SITE && (
            <CustomLink
              id="support-site-line"
              data-cta-name-en="Support Site"
              data-cta-name-th="เว็บไซต์สนับสนุน"
              data-cta-type="Link"
              style={{ marginRight: 8 }}
              theme={theme}
              href={lineTHRef}
              target="_blank"
              onClick={() => trackClickFooterSocialIcon('line')}
            >
              <img width={24} height={24} src={lineIcon} className={classes.socialIcon} alt="Line" />
            </CustomLink>

          )}
          {configuration.siteCode === SITES.THAILAND_SITE && (
            <CustomLink
              id="support-site-twitter"
              data-cta-name-en="Support Site"
              data-cta-name-th="เว็บไซต์สนับสนุน"
              data-cta-type="Link"
              style={{ marginRight: 8 }}
              theme={theme}
              href={twitterTHRef}
              target="_blank"
              onClick={() => trackClickFooterSocialIcon('twitter')}
            >
              <img width={24} height={24} src={twitterIcon} className={classes.socialIcon} alt="Twitter" />
            </CustomLink>
          )}
        </div>
      </Grid>
      {configuration.siteCode === SITES.THAILAND_SITE && (
        <Grid item xs={12} md={2} style={{ paddingRight: 0 }}>
          <CustomText theme={theme}>
            {word('Footer.VerifiedBy')}
          </CustomText>
          <div className={classes.logo}>
            <CustomLink
              style={{ marginRight: 8 }}
              theme={theme}
              as="span"
            >
              <img width={83} height={32} src={dbdLogo} alt="DBD" className={classes.dbdLogo} />
            </CustomLink>
          </div>
        </Grid>
      )}
    </Grid>
  );
};

export default SupportSite;
